var _path;
import * as React from "react";
function SvgBookmarkOutline(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 4H11a3 3 0 00-3 3v29l12-7 12 7V7a3 3 0 00-3-3zm1 28.518l-10-5.833-10 5.833V7c0-.551.449-1 1-1h18c.551 0 1 .449 1 1v25.518z"
  })));
}
export default SvgBookmarkOutline;